import React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import CreateOrEditManualRefund from './CreateOrEditManualRefund';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  borderRadius: '8px',
};

const EditManualRefundModal = ({
  refundLocation,
  refund,
  onClose,
  reFetch,
  updateStatus,
  editableFields,
}) => {
  return (
    refund && (
      <Modal open={!!refund} onClose={onClose}>
        <Box sx={modalStyle}>
          <CreateOrEditManualRefund
            refundLocation={refundLocation}
            refundId={refund?.id}
            updateStatus={updateStatus}
            onClose={async () => {
              await reFetch();
              onClose(false);
            }}
            editableFields={editableFields}
          />
        </Box>
      </Modal>
    )
  );
};

export default EditManualRefundModal;
